import { render } from "./Footer.vue?vue&type=template&id=3d944640&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=3d944640&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.4_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d944640"]])

export default __exports__